'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _compact2 = require('lodash/compact');

var _compact3 = _interopRequireDefault(_compact2);

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.font = font;
exports.border = border;
exports.padding = padding;
exports.margin = margin;
exports.size = size;

var _colors = require('./colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function unit(number) {
  if (typeof number === 'number') {
    return number + 'px';
  }
  return number;
}

function font() {
  var fontSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 14;
  var weight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;
  var family = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '"Lato", arial, sans-serif';

  return {
    fontSize: unit(fontSize),
    fontWeight: weight,
    fontFamily: family
  };
}

function border() {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _colors.COLORS.CHARCOAL;
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'solid';

  return {
    border: unit(width) + ' ' + color + ' ' + type
  };
}

function padding(topValue, rightValue, bottomValue, leftValue) {
  var numbered = (0, _compact3.default)([topValue, rightValue, bottomValue, leftValue].map(unit));

  var _numbered = _slicedToArray(numbered, 4),
      top = _numbered[0],
      right = _numbered[1],
      bottom = _numbered[2],
      left = _numbered[3];

  if (numbered.length === 1) {
    return { padding: top };
  }
  if (numbered.length === 2) {
    return { padding: top + ' ' + right };
  }
  return { padding: top + ' ' + right + ' ' + bottom + ' ' + left };
}

function margin(topValue, rightValue, bottomValue, leftValue) {
  var numbered = (0, _compact3.default)([topValue, rightValue, bottomValue, leftValue].map(unit));

  var _numbered2 = _slicedToArray(numbered, 4),
      top = _numbered2[0],
      right = _numbered2[1],
      bottom = _numbered2[2],
      left = _numbered2[3];

  if (numbered.length === 1) {
    return { margin: top };
  }
  if (numbered.length === 2) {
    return { margin: top + ' ' + right };
  }
  return { margin: top + ' ' + right + ' ' + bottom + ' ' + left };
}

function size(widthValue, heightValue) {
  var numbered = (0, _compact3.default)([widthValue, heightValue].map(unit));

  var _numbered3 = _slicedToArray(numbered, 2),
      width = _numbered3[0],
      height = _numbered3[1];

  if (numbered.length === 1) {
    return {
      width: width,
      height: width
    };
  }
  return {
    width: width,
    height: height
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/styles/helpers.js
// module id = 65
// module chunks = 0